import axios from 'axios';

// API Base URL - .env.production veya .env.development dosyasından okunur
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5159';
const axiosInstance = axios.create({
    baseURL: API_BASE_URL
});

// Request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                const user = JSON.parse(userStr);
                if (user && user.token) {
                    config.headers.Authorization = `Bearer ${user.token}`;
                }
            } catch (error) {
                console.error('Error parsing user data:', error);
            }
        }

        // ModSecurity bypass: TÜM PUT ve DELETE isteklerini POST'a çevir
        if (config.method === 'put' && config.url?.includes('/api/')) {
            const urlParts = config.url?.split('/');
            const lastPart = urlParts?.[urlParts.length - 1];
            
            // Sayısal ID kontrolü - eğer son kısım sayıysa basit update
            if (lastPart && /^\d+$/.test(lastPart)) {
                const id = lastPart;
                const basePath = urlParts?.slice(0, -1).join('/');
                config.method = 'post';
                config.url = `${basePath}/update/${id}`;
                console.log(`PUT -> POST çevrildi: ${config.url}`);
            } else {
                // Özel path'ler için (örn: /1/durum, /1/logo) - olduğu gibi bırak
                console.log(`PUT isteği özel path, değiştirilmedi: ${config.url}`);
            }
        } else if (config.method === 'delete' && config.url?.includes('/api/')) {
            const urlParts = config.url?.split('/');
            const lastPart = urlParts?.[urlParts.length - 1];
            
            // Sayısal ID kontrolü
            if (lastPart && /^\d+$/.test(lastPart)) {
                const id = lastPart;
                const basePath = urlParts?.slice(0, -1).join('/');
                config.method = 'post';
                config.url = `${basePath}/delete/${id}`;
                console.log(`DELETE -> POST çevrildi: ${config.url}`);
            } else {
                // Özel path'ler için (örn: /1/logo) - backend'de /delete/1/logo endpoint'i var
                // URL yapısını koru ama POST'a çevir ve delete ekle
                const secondLastPart = urlParts?.[urlParts.length - 2];
                if (secondLastPart && /^\d+$/.test(secondLastPart)) {
                    // /api/Kurumsal/1/logo -> /api/Kurumsal/delete/1/logo
                    const id = secondLastPart;
                    const suffix = lastPart;
                    const basePath = urlParts?.slice(0, -2).join('/');
                    config.method = 'post';
                    config.url = `${basePath}/delete/${id}/${suffix}`;
                    console.log(`DELETE (özel path) -> POST çevrildi: ${config.url}`);
                } else {
                    console.log(`DELETE isteği özel path, değiştirilmedi: ${config.url}`);
                }
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('API Error:', error.response);
        if (error.response?.status === 401) {
            // Login endpoint'inden gelen 401'leri yönlendirme — hata caller'a iletilsin
            const url: string = error.config?.url ?? '';
            const isLoginEndpoint = url.includes('/api/Auth/login');
            if (!isLoginEndpoint) {
                localStorage.removeItem('user');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
